import Services from './base-services'

const service = new Services('parameters')

export default {
    getParameterByName(name: string) {
        return service.get(`findOneByName?name=${name}`)
    },
}
